import { nextTick } from 'vue';
import { addClass, getStyle, removeClass } from './tools/style';
import { createLoadingComponent } from './loading';
import { useZIndex, defaultInitialZIndex } from './hooks/use-z-index';

let fullscreenInstance;

const resolveOptions = options => {
  let target;
  if (typeof options.target === 'string') {
    target = document.querySelector(options.target) ?? document.body;
  } else {
    target = options.target || document.body;
  }
  return {
    parent: target === document.body || options.body ? document.body : target,
    background: options.background || '',
    svg: options.svg || '',
    svgViewBox: options.svgViewBox || '',
    text: options.text || '',
    fullscreen: target === document.body && (options.fullscreen ?? true),
    lock: options.lock ?? false,
    customClass: options.customClass || '',
    visible: options.visible ?? true,
    beforeClose: options.beforeClose,
    closed: options.closed,
    target
  };
};

const addStyle = async (options, parent, instance) => {
  const { nextZIndex } = useZIndex(defaultInitialZIndex);

  if (options.fullscreen || options.parent === document.body) {
    instance.originalPosition.value = getStyle(document.body, 'position');
  } else {
    instance.originalPosition.value = getStyle(parent, 'position');
  }
  instance.$el.style.zIndex = nextZIndex();
};

const addClassList = (options, parent, instance) => {
  if (
    !['absolute', 'fixed', 'sticky'].includes(instance.originalPosition.value)
  ) {
    addClass(parent, 'sbt-loading-parent--relative');
  } else {
    removeClass(parent, 'sbt-loading-parent--relative');
  }
  if (options.fullscreen && options.lock) {
    addClass(parent, 'sbt-loading-parent--hidden');
  } else {
    removeClass(parent, 'sbt-loading-parent--hidden');
  }
};

const Loading = (options = {}) => {
  const modifiedOptions = resolveOptions(options);

  if (modifiedOptions.fullscreen && fullscreenInstance) {
    return fullscreenInstance;
  }

  const instance = createLoadingComponent({
    ...modifiedOptions,
    closed: () => {
      modifiedOptions.closed?.();
      if (modifiedOptions.fullscreen) fullscreenInstance = undefined;
    }
  });

  addStyle(modifiedOptions, modifiedOptions.parent, instance);
  addClassList(modifiedOptions, modifiedOptions.parent, instance);

  modifiedOptions.parent.appendChild(instance.$el);

  nextTick(() => (instance.visible.value = modifiedOptions.visible));

  if (modifiedOptions.fullscreen) {
    fullscreenInstance = instance;
  }
  return instance;
};

export default Loading;
